@if (design(); as flag) {
  <span class="flag-chip" [class.flag-chip--vertical]="flag.axis === 'vertical'" aria-hidden="true">
    @for (band of flag.bands; track $index) {
      <span
        class="flag-chip__band"
        [style.background]="band.color"
        [style.flexGrow]="band.weight ?? 1"
      ></span>
    }
    @if (flag.cross) {
      <span class="flag-chip__cross"></span>
    }
    @if (flag.canton; as canton) {
      <span class="flag-chip__canton" [style.background]="canton"></span>
    }
    @if (flag.emblem) {
      <!-- The crest, reduced to what survives at this size: a condor over a
           shield. Not a reproduction — a mark that says one is there, which is
           the only thing that separates this flag from Colombia's. -->
      <svg class="flag-chip__emblem" viewBox="0 0 24 16" aria-hidden="true">
        <path d="M6.6 6.1 Q9.3 3.6 12 5.2 Q14.7 3.6 17.4 6.1 Q14.6 5.3 12 6.9 Q9.4 5.3 6.6 6.1 Z" />
        <ellipse cx="12" cy="10" rx="2.5" ry="3.1" />
      </svg>
    }
  </span>
}
